"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var lodash_uniqueid_1 = tslib_1.__importDefault(require("lodash.uniqueid"));
var RolesConnector = /** @class */ (function (_super) {
    tslib_1.__extends(RolesConnector, _super);
    function RolesConnector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.iframeEl = null;
        _this.el = null;
        _this.uid = (0, lodash_uniqueid_1["default"])();
        _this.handleLoad = function () {
            var _a = _this.props, accessToken = _a.accessToken, appId = _a.appId, appSpace = _a.appSpace, onClose = _a.onClose;
            window.removeEventListener('message', _this.handleMessage);
            window.addEventListener('message', _this.handleMessage, false);
            if (typeof onClose === 'function') {
                _this.sendMessages([_this.formatMessage('ON_CLOSE_FN_SET', appId)]);
            }
            _this.sendMessages([
                _this.formatMessage('SET_APP_ID', appId),
                _this.formatMessage('SET_APP_SPACE', appSpace),
                _this.formatMessage('SET_ACCESS_TOKEN', accessToken),
            ]);
        };
        _this.handleMessage = function (e) {
            if (Array.isArray(e.data)) {
                _this.processAlienMessages(e.data);
            }
        };
        _this.processAlienMessages = function (messages) {
            if (messages === void 0) { messages = []; }
            messages.forEach(_this.processSingleAlienMessage);
        };
        _this.processSingleAlienMessage = function (params) {
            var instanceId = params.instanceId, type = params.type, payload = params.payload;
            if (instanceId !== _this.uid) {
                return;
            }
            var _a = _this.props, onError = _a.onError, onUnauthorized = _a.onUnauthorized, onClose = _a.onClose;
            switch (type) {
                case 'ERROR_GENERIC':
                    if (typeof payload === 'string') {
                        onError(payload);
                    }
                    else {
                        throw Error("Unexpected error \"".concat(payload, "\"."));
                    }
                    break;
                case 'ERROR_AUTH':
                    onUnauthorized();
                    break;
                case 'CLOSE':
                    onClose();
                    break;
                default:
            }
        };
        _this.formatMessage = function (type, payload) {
            return {
                instanceId: _this.uid,
                type: type,
                payload: payload
            };
        };
        _this.sendMessages = function (messages) {
            if (_this.iframeEl && _this.iframeEl.contentWindow) {
                _this.iframeEl.contentWindow.postMessage(messages, '*');
            }
        };
        return _this;
    }
    RolesConnector.prototype.componentDidMount = function () { };
    RolesConnector.prototype.componentWillUnmount = function () {
        window.removeEventListener('message', this.handleMessage);
    };
    RolesConnector.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.opened, opened = _b === void 0 ? false : _b, _c = _a.rolesBaseUrl, rolesBaseUrl = _c === void 0 ? 'https://roles.sportnet.online' : _c;
        if (!opened) {
            return null;
        }
        return (react_1["default"].createElement("iframe", { frameBorder: "0", onLoad: this.handleLoad, ref: function (el) {
                _this.iframeEl = el;
            }, style: {
                position: 'fixed',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 99999
            }, title: "Spr\u00E1va pou\u017E\u00EDvate\u013Eov", src: "".concat(rolesBaseUrl, "/?instance_id=").concat(this.uid) }));
    };
    return RolesConnector;
}(react_1.Component));
exports["default"] = RolesConnector;
